// modules
import { createAction } from 'redux-actions'

// actions
export const setRecentlyViewedPatients = createAction(
  'SET_RESENTLY_VIEWED_PATIENTS'
)
export const resetSearchPatientList = createAction('RESET_SEARCH_PATIENT_LIST')
